import { render } from "./processTransport.vue?vue&type=template&id=1fde2a6f&scoped=true&ts=true"
import script from "./processTransport.vue?vue&type=script&lang=ts"
export * from "./processTransport.vue?vue&type=script&lang=ts"

import "./processTransport.vue?vue&type=style&index=0&id=1fde2a6f&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fde2a6f"]])

export default __exports__